import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import Main from '../../components/Main/Main';
import Logo from '../../components/Logo/Logo';
import Waves from '../../components/Waves/Waves';

import './form.scss';

export const ProspectLayout = (props) => {
    return (
        <Main className="authentication">
            <Helmet
                title={props.pageTitle}
            />
            <Waves />
            <div className="prospect">
                <div className="prospect__wrapper">
                    <div className="prospect__container">
                        <div className="prospect__logo">
                            <Logo
                                height={41}
                                width={205}
                            />
                        </div>
                        <h1 className="prospect__title">{props.contentTitle}</h1>
                        {props.children}
                    </div>
                </div>
            </div>
        </Main>
    );
};

ProspectLayout.propTypes = {
    contentTitle: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    pageTitle: PropTypes.string,
};

ProspectLayout.defaultProps = {
    contentTitle: 'Try our free assessment',
    children: null,
    pageTitle: 'Prospects',
};
const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export const ConnectedProspectLayout = connect(mapStateToProps, mapDispatchToProps)(ProspectLayout);


function withProspectLayout(Component, contentTitle, pageTitle) {
    return props => (
        <ConnectedProspectLayout
            contentTitle={contentTitle}
            pageTitle={pageTitle}
            {...props}
        >
            <Component {...props} />
        </ConnectedProspectLayout>
    );
}

export default withProspectLayout;
